import React from 'react';

const TableContextMenu = ({
  show,
  x,
  y,
  onInsertRowBefore,
  onInsertRowAfter,
  onInsertColumnBefore,
  onInsertColumnAfter,
  onDeleteRow,
  onDeleteColumn,
  onClose
}) => {
  if (!show) return null;

  const handleAction = (action) => {
    action();
    onClose();
  };

  return (
    <div
      className="fixed bg-white border border-gray-300 rounded shadow-lg z-50 py-1"
      style={{ left: x, top: y }}
    >
      <button
        onClick={() => handleAction(onInsertRowBefore)}
        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
      >
        Insert Row Above
      </button>
      <button
        onClick={() => handleAction(onInsertRowAfter)}
        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
      >
        Insert Row Below
      </button>
      <button
        onClick={() => handleAction(onInsertColumnBefore)}
        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
      >
        Insert Column Left
      </button>
      <button
        onClick={() => handleAction(onInsertColumnAfter)}
        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
      >
        Insert Column Right
      </button>
      <hr className="my-1" />
      <button
        onClick={() => handleAction(onDeleteRow)}
        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 text-red-600"
      >
        Delete Row
      </button>
      <button
        onClick={() => handleAction(onDeleteColumn)}
        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 text-red-600"
      >
        Delete Column
      </button>
    </div>
  );
};

export default TableContextMenu;